import React from 'react';
import { ListGroup, ListGroupItem } from 'reactstrap';

const VersionerCollaboratorList = (props) => {
  const {
    collaborators,
  } = props;

  return (
    <ListGroup>
      {
        _.map(collaborators, (collaborator, index) => {
          return (
            <ListGroupItem key={ `CollaboratorListGroupItem-${collaborator.id}` } className="small">
              { collaborator.user.email }
            </ListGroupItem>
          )
        })
      }
    </ListGroup>
  )
}

export default VersionerCollaboratorList;